import Svg, { SvgProps, Path } from 'react-native-svg';

const WarningIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M15 3a2 2 0 0 0-1.846 1.229L2.301 22.947v.002A2 2 0 0 0 2 24a2 2 0 0 0 2 2 2 2 0 0 0 .14-.006l.005.006h21.71l.004-.008A2 2 0 0 0 26 26a2 2 0 0 0 2-2 2 2 0 0 0-.3-1.053l-.016-.027a2 2 0 0 0-.002-.002L16.846 4.228A2 2 0 0 0 15 3zm-1.213 8.36h2.426l-.201 6.472h-2.024l-.2-6.473zm1.217 8.45c.822 0 1.314.443 1.314 1.198 0 .74-.492 1.181-1.314 1.181-.828 0-1.324-.44-1.324-1.181 0-.755.495-1.197 1.324-1.197z" />
  </Svg>
);

export default WarningIcon;
